export default "__VITE_ASSET__dOyqH4nu__"